import React from "react";
import { Switch } from "antd";
import { $t } from "~/i18n.js";

export const SwitchYesNo = ({
  id = "",
  value = false,
  onChange = (e) => {},
  disabled = false,
  yes=$t("Ja"),
  no=$t("Nee"),
  ...args
}) => {
  return (
    <Switch
      disabled={disabled}
      checked={value}
      onChange={onChange}
      checkedChildren={yes}
      unCheckedChildren={no}
      {...args}
    />
  );
};
